import { Component, Inject } from '@angular/core';
import { AngularFireDatabase } from '@angular/fire/compat/database';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { environment } from 'src/environment';
import { emsCompetition, emsTeam, emsVeto } from 'src/models/emsModels';

@Component({
  selector: 'app-veto-info-dialog',
  templateUrl: './veto-info-dialog.component.html',
  styleUrl: './veto-info-dialog.component.scss'
})
export class VetoInfoDialogComponent {

  veto = new emsVeto();
  competition = new emsCompetition();
  teamOne = new emsTeam();
  teamTwo = new emsTeam();
  vetoDBRef: any;
  competitionDBRef: any;
  teamOneDBRef: any;
  teamTwoDBRef: any;

  constructor(public dialogRef: MatDialogRef<VetoInfoDialogComponent>, @Inject(MAT_DIALOG_DATA) public data: any, private db: AngularFireDatabase) {}
  
  ngOnInit() {  
    this.dialogRef.backdropClick().subscribe( x => {
      this.dialogRef.close();
    });
    this.dialogRef.keydownEvents().subscribe(event => {
      if (event.key === "Escape") {
        this.dialogRef.close();
      }
    });
    if (this.data.vetoUID) {
      this.loadVeto(this.data.vetoUID);
    }
    else if (this.data.veto) {
      this.veto = this.data.veto;
      this.loadTeams(this.data.veto.teamOne, this.data.veto.teamTwo);
      this.loadCompetition(this.data.veto.competition); 
    }
  }

  ngOnDestroy() {
    if (this.vetoDBRef) {
      this.vetoDBRef.off('value');
    };
    if (this.competitionDBRef) {
      this.competitionDBRef.off('value');
    };
    if (this.teamOneDBRef) {
      this.teamOneDBRef.off('value');
    };
    if (this.teamTwoDBRef) {
      this.teamTwoDBRef.off('value');
    };
  }
  
  transformExecutorName(executor: string) {
    if (executor == 'teamA' && this.veto.teamA) {
      return this.veto.teamA;
    }
    else if (executor == 'teamA') {
      return "Team A";
    }
    else if (executor == 'teamB' && this.veto.teamB) {
      return this.veto.teamB;
    }
    else if (executor == 'teamB') {
      return "Team B";
    }
    else if (executor == 'startingTeam' && this.veto.startingTeam) {
      return this.veto.startingTeam;
    }
    else if (executor == 'startingTeam') {
      return "TBD";
    }
    else if (executor == 'admin') {
      return "Admin";
    } 
    else if (executor == 'system') {
      return "";
    } 
    else {
      return executor;
    }
  }

  loadVeto(vetoUID: string) {
    this.vetoDBRef = this.db.database.app.database(environment.emsDatabaseURL).ref('/vetos/lobbies/' + vetoUID);
    this.vetoDBRef.on('value', x => {
      var vetoData = x.toJSON() as emsVeto;
      vetoData.uid = x.key;
      this.loadTeams(vetoData.teamOne, vetoData.teamTwo);
      this.loadCompetition(vetoData.competition); 
      if (vetoData.pool) {
        vetoData.pool = Object.values(vetoData.pool);
      } else {
        vetoData.pool = [];
      }
      if (vetoData.actions) {
        vetoData.actions = Object.values(vetoData.actions);
      } else {
        vetoData.actions = [];
      }
      this.veto = vetoData;
    });
  }

  loadCompetition(competitionID: string) {
    this.competitionDBRef = this.db.database.app.database(environment.emsDatabaseURL).ref('/competitions/' + competitionID);
    this.competitionDBRef.on('value', x => {
      this.competition = x.toJSON() as emsCompetition;
    });
  }
  
  loadTeams(teamOneID: string, teamTwoID: string) {
    this.teamOneDBRef = this.db.database.app.database(environment.emsDatabaseURL).ref('/teams/' + teamOneID);
    this.teamOneDBRef.on('value', x => {
      this.teamOne = x.toJSON() as emsTeam;
    });
    this.teamTwoDBRef = this.db.database.app.database(environment.emsDatabaseURL).ref('/teams/' + teamTwoID);
    this.teamTwoDBRef.on('value', x => {
      this.teamTwo = x.toJSON() as emsTeam;
    });
  }
}
